import React, { useEffect, useState, useCallback, } from 'react';
import { Paper, Grid, Divider, Typography, Stepper, Step, StepButton,
} from '@mui/material';
import PropertyInfo from './PropertyInfo';
import { useSnackbar } from 'notistack';
// import UploadPropertyFiles from './UploadPropertyFiles';
import { getCities, getStates, getLibraryDetails, getLibraryPhotoNames } from 'services/libraries';
import Kyc from './kyc';
import UploadPropertyFiles from './UploadPropertyFiles';
import PosterImage from './posterImage';

const EditProperty = ({libraryId, onSuccess, onFailure}) => {

  const steps = ['Info','KYC','Images', 'Poster Image'];


  /** Hooks */
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  // const [libraryId, setLibraryId] = useState(propertyId || null);
  const [libraryData, setLibraryData] = useState(null);
  const [libraryPhotos, setLibraryPhotos] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getCityList();
    getStateList();
    return () => {};
  }, []);

  useEffect(() => {
    if(libraryId) {
      getLibraryData(libraryId)
    }
  
    return () => {};
  }, [libraryId]);
  
  

  const getCityList = () => {
    getCities().then(({response, error}) => {
      if(response){
        setCities([...response]);
      } else {
        // enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const getStateList = () => {
    getStates().then(({response, error}) => {
      if(response){
        setStates([...response]);
      } else {
        // enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step, label) => () => {
    if(!!libraryId){ 
      setActiveStep(step);
      if(label === 'Images') {
        getLibraryPhotos(libraryId);
      }
    }
  };

  // const handleComplete = useCallback(() => {
  //   const newCompleted = completed;
  //   newCompleted[activeStep] = true;
  //   setCompleted(newCompleted);
  //   if(!isLastStep()){
  //     handleNext();
  //   }
  // }, [activeStep, setCompleted, completed]);

  // const handleReset = () => {
  //   setActiveStep(0);
  //   setCompleted({});
  // };

  const onLibraryEditedSuccessfully = useCallback((libraryData) => {
    onSuccess();
    setLibraryData(null);
    // setLibraryData(libraryData);
    // handleComplete();
  }, []);


  const getLibraryData = (propertyId) => {
    getLibraryDetails({libraryId: propertyId}).then(({response, error}) => {
      if(response){
        setLibraryData({...response})
      } else {
        onFailure();
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const getLibraryPhotos = (propertyId) => {
    getLibraryPhotoNames({libraryId: propertyId}).then(({response, error}) => {
      if(response){
        setLibraryPhotos([...response]);
      } else {
        // enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }
  
  return (
    <Paper sx={{ minWidth: 275, p: 4, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        View/Edit Library
      </Typography>
      <Divider />
      <Grid container spacing={4} sx={{mt: 2}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Stepper alternativeLabel nonLinear={!!libraryId} activeStep={activeStep} sx={{pb: 2 }}>
            {steps.map((label, index) => (
              <Step key={label} completed={completed[index]}>
                <StepButton color="inherit" onClick={handleStep(index, label)}>
                  {label}
                  {/* {index == 2 && <Typography variant="caption" component="div">Optional</Typography>} */}
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </Grid>
      </Grid>
      {activeStep === 0 ? (
        <PropertyInfo cities={cities} states={states} onSuccess={onLibraryEditedSuccessfully} libraryId={libraryId} libraryData={libraryData} />
      ) : null}

      {activeStep === 1 ? (
        <Kyc  propertyId={libraryId} propertyData={libraryData} handleNext={handleNext} handleBack={handleBack} />
      ) : null}

      {activeStep === 2 ? (
        <UploadPropertyFiles libraryId={libraryId} libraryPhotos={libraryPhotos} />
      ) : null}

      {activeStep === 3 ? (
        <PosterImage libraryId={libraryId} />
      ) : null}
    </Paper>
  );
}
 
export default React.memo(EditProperty);
